import React from "react";
import store from "./redux/store";
import HooksWrapper from "./hookWrapper";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Toaster />
    <HooksWrapper>
      <App />
    </HooksWrapper>
  </Provider>
);

reportWebVitals();
